import { getInitials } from '@utils/textHelpers';

export const useInitials = (name?: string, lastName?: string, noOfInitials: number = 2) => {
  const canSplit = name ? name.split(' ').filter((s) => s) : [];
  let fName: string = name || '';
  let lName: string = lastName || '';
  if (canSplit?.length >= 2 && noOfInitials === 2) {
    fName = canSplit[0];
    lName = canSplit[canSplit.length - 1];
  }

  let initials = '';
  if (fName && lName) initials = getInitials(fName) + getInitials(lName);
  if (fName && !lName) {
    if (canSplit?.length < 2) {
      initials = getInitials(fName, 2);
    } else {
      initials = getInitials(fName, noOfInitials);
    }
  }
  return initials.trim();
};
